import { createContext, useContext, useState } from 'react';

const VehicleContext = createContext();

export const useVehicle = () => useContext(VehicleContext);

export const VehicleProvider = ({ children }) => {
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const autoSelectVehicle = (vehicleList) => {
    setVehicles(vehicleList);
    if (vehicleList.length === 1) {
      setSelectedVehicle(vehicleList[0]);
    }
  };

  return (
    <VehicleContext.Provider value={{
      vehicles,
      selectedVehicle,
      setSelectedVehicle,
      autoSelectVehicle
    }}>
      {children}
    </VehicleContext.Provider>
  );
};
